// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamsModal .button-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center; }

.TeamsModal .teams-wrapper {
  display: flex;
  flex: 1 1 auto; }
`, "",{"version":3,"sources":["webpack://./src/components/TeamsModal.scss"],"names":[],"mappings":"AAAA;EAEI,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB,EAAA;;AALvB;EASI,aAAa;EACb,cAAc,EAAA","sourcesContent":[".TeamsModal {\n  .button-wrapper {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .teams-wrapper {\n    display: flex;\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
